import { NavItem } from './nav-item/nav-item';

export const navItems: NavItem[] = [
  {
    navCap: 'Menu',
  },
  {
  id: 5,
  displayName: 'Dashboard',
  iconName: 'layout-dashboard',
  route: '/dashboard',
  },
  {
  id: 3,
  displayName: 'Model Creation',
  iconName: 'shirt',
  route: '/products',
  },
  {
    id: 1,
    displayName: 'Labdips',
    iconName: 'color-swatch',
    route: '/labdips',
  },
  {
  id: 2,
  displayName: 'Bulks',
  iconName: 'file-text',
  route: '/bulks',
  },
   {
  id: 4,
  displayName: 'Sourcing',
  iconName: 'file-analytics',
  route: '/sourcing',
  },
  {
  id: 8,
  displayName: 'Sampling',
  iconName: 'file-analytics',
  route: '/protos',
  },
  {
  id: 6,
  displayName: 'Trims',
  iconName: 'tags',
  route: '/trims',
  },
  {
  id: 7,
  displayName: 'Print & Embroidery',
  iconName: 'photo',
  route: '/print-embroidery',
  },
  {
    id: 1002, // always shown for internal users (see FullComponent.updateNavItems)
    displayName: 'Notification hub',
    iconName: 'bell-ringing',
    route: '/notifications/hub',
  },
  {
    id: 999, // id que não existe em boards, só admin vai ver na prática
    displayName: 'Settings',
    iconName: 'settings',
    route: '/settings',
  },
];